var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSendRightEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.594 5.344.437 1.875L5.97 16 4.03 24.781l-.437 1.875 1.781-.718 22-9L29.656 16l-2.281-.937-22-9Zm2.781 3.312L21.906 15H7.781ZM7.781 17h14.125L6.375 23.344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSendRightEmpty);
export default __webpack_public_path__ + "static/media/arrow-send-right-empty.e0d1e2807b6cfce765b63cc5b2c55a29.svg";
export { ForwardRef as ReactComponent };